<template>
  <q-layout view="lHr Lpr lfr" class="frontend bg-blue-grey-1">
    <q-header bordered class="bg-white">
      <!--Toolbar-->
      <q-toolbar class="text-black" :class="scopeAddClasses('default.classes.layout.header.toolbar')">
        <q-toolbar-title class="text-body-1 text-weight-light no-padding toolbar">
          <div class="row items-center justify-between">
            <div class="col-md-6 col-auto">
              <div class="row justify-start">
                <div class="col-auto menu-button">
                  <div class="row full-height" :class="scopeAddClasses('default.classes.layout.header.hamburgerIcon')">
                    <div class="col-auto hamburger-menu">
                      <q-btn
                        v-bind="scopeAddProps('default.props.layout.header.menuButton')"
                        icon="menu"
                        dense
                        class="full-height"
                        color="primary"
                        @click="leftDrawerOpen = !leftDrawerOpen"
                      >
                      </q-btn>
                    </div>
                  </div>
                </div>
                <div class="col-md-10">
                  <div class="row items-center q-col-gutter-xs">
                    <div class="col-auto">
                      <q-btn v-go-back.single="store.backRoute" icon="arrow_back" dense class="platform-android-only" />
                    </div>
                    <div class="q-pt-md gt-sm" :class="scopeAddClasses('default.classes.layout.header.logo')">
                      <img class="logo responsive" :src="$configs.app.images.header.logo" alt="Elken" />
                    </div>
                    <div class="col-md-auto gt-sm clock">
                      <simple-clock class="text-primary-darkened" />
                    </div>
                    <div class="col-md-auto gt-sm">
                      <q-btn
                        size="sm"
                        dense
                        color="grey-6"
                        icon="fas fa-lightbulb"
                        flat
                        @click="openCloseModal({ name: 'appHelperModal', status: true })"
                      >
                        <q-tooltip>
                          ? Helper
                        </q-tooltip>
                      </q-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-auto">
              <div class="row justify-end items-center q-col-gutter-xs">
                <div class="col-md-auto">
                  <FreshWidgetButton></FreshWidgetButton>
                </div>
                <div class="col-md-auto">
                  <q-btn-dropdown
                    dense
                    flat
                    :label="getCountryCode()"
                    color="primary"
                    icon="fas fa-globe"
                    :offset="[0, 10]"
                    square
                    fit
                  >
                    <q-list dense>
                      <q-item
                        v-for="(country, index) in countriesOptions.options"
                        :key="`country-${index}`"
                        v-close-popup
                        :clickable="getCountryCode() !== country.code_iso_2"
                        :active="getCountryCode() === country.code_iso_2"
                        active-class="bg-grey-3"
                        @click="updateGlobalCountry(country.value)"
                      >
                        <q-item-section avatar color="primary">
                          <country-flag :country="country.code_iso_2" size="normal" />
                        </q-item-section>
                        <q-item-section>
                          <q-item-label>{{ country.label }}</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                          <q-icon
                            :name="getCountryCode() === country.code_iso_2 ? 'done' : ''"
                            color="primary-darkened"
                          />
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-btn-dropdown>
                </div>
                <div v-if="userInfo.name" class="col-md-auto">
                  <q-btn dense color="primary" flat icon="fas fa-user-circle">
                    <q-menu :offset="[0, 10]" square fit>
                      <div class="row no-wrap q-pa-md">
                        <div class="column">
                          <div class="text-subtitle2">
                            Email
                          </div>
                          <div class="text-caption">
                            {{ userInfo.email }}
                          </div>
                          <div class="text-caption text-uppercase text-center">
                            <q-chip icon="admin_panel_settings">
                              {{ userInfo.user_type }}
                            </q-chip>
                          </div>
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column items-center">
                          <q-avatar size="72px">
                            <q-img class="text-primary-darkened" src="~/assets/profile/user.svg" />
                          </q-avatar>
                          <div class="text-subtitle1 q-mt-md q-mb-xs text-capitalize">{{ userInfo.name }}</div>
                          <!-- Todo Removed -->
                          <!--  <q-btn v-close-popup color="primary" label="Change Password" rounded unelevated size="sm" />-->
                        </div>
                      </div>
                    </q-menu>
                  </q-btn>
                </div>
                <div class="col-md-auto">
                  <q-btn color="primary" flat dense>
                    <audio ref="audioElm" src="ding.mp3" />
                    <span class="text-negative" :class="{ 'animate-blink': notificationCount > 0 }">{{
                      notificationCount > 0 ? notificationCount + '+' : notificationCount
                    }}</span>
                    <q-icon name="fas fa-bell" />
                  </q-btn>
                </div>
                <div class="col-md-auto">
                  <q-btn
                    dense
                    flat
                    :loading="isProcessingRefreshToken"
                    color="primary"
                    :icon="$configs.app.images.header.icons.logout"
                    @click="logoutHandler"
                  />
                </div>
                <div class="col-md-auto gt-xs">
                  <q-icon class="pd-2" :color="websocket.connected ? 'positive' : 'negative'" name="lens" />
                </div>
                <div v-if="!websocket.connected" class="col-md-auto gt-sm">
                  <q-spinner-puff color="secondary" :size="20" />
                  <q-tooltip anchor="center left" self="center right" :offset="[10, 10]">
                    Re-connecting to live notification server ...
                  </q-tooltip>
                </div>
              </div>
            </div>
          </div>
        </q-toolbar-title>
      </q-toolbar>
      <!--Toolbar End-->
      <!--Info-->
      <q-banner
        v-if="$configs.toggles.notification.oldDashboard === true"
        class="bg-blue-2 text-dark text-subtitle1"
        dense
        inline-actions
      >
        We're updating the Backoffice UI, if you experiencing any bottleneck please use old view instead.
        <template slot="action">
          <q-btn
            size="sm"
            rounded
            outline
            unelevated
            color="primary-darkened"
            label="Bring me to old Dashboard"
            @click="openURL('https://backend-old.elken.com')"
          />
        </template>
      </q-banner>
      <!--Info Ends-->
      <!--Update Alert-->
      <q-banner v-if="getIsUpdateAvailable" class="bg-amber-3 text-dark text-subtitle2" dense inline-actions>
        {{ $ts('banner.newUpdate.text.message') }}
        <span class="text-subtitle2 text-negative"
          >({{ $t('Common.AutoUpdateIn.Text', { time: getTimerMinuets }) }})</span
        >
        <template slot="action">
          <q-btn
            size="sm"
            rounded
            unelevated
            color="dark"
            :label="$t('Common.ClickHereToUpdate.Text')"
            @click="refreshApp"
          />
        </template>
      </q-banner>
      <!--Update Alert Ends-->
      <!--IsDevelopment site alert-->
      <q-banner v-if="isDevelopmentMode" class="bg-red-7" dense inline-actions>
        <div class="row items-baseline q-col-gutter-sm">
          <div class="col-auto">
            <q-icon color="grey-6" name="img:/lab-bottle-round-outline-white.gif" size="sm" />
          </div>
          <div class="col-auto">
            {{ $ts('words.testingSiteNotice') }}
          </div>
        </div>
      </q-banner>
      <!--IsDevelopment site alert Alert Ends-->
    </q-header>
    <!--Sidebar-->
    <StandardSideMenu v-model="leftDrawerOpen" :sidebar-navigations="getStandardMenu" />
    <!--Sidebar End-->
    <!--Content-->
    <q-page-container class="general-page" :class="{ 'no-scroll': $wait.any }">
      <q-page padding class="row items-stretch items-center">
        <div class="col-12">
          <transition enter-active-class="animated fadeIn" :duration="500" @leave="resetScroll">
            <router-view />
          </transition>
        </div>
        <Loader
          :message="$wait.is('retryRequest') ? $t('Common.RetryRequest.Text') : ''"
          :visible="getIsLoading && !isAnyModalActive"
        />
      </q-page>
    </q-page-container>
    <!--Content End-->
    <q-footer class="bg-transparent">
      <q-toolbar>
        <q-toolbar-title>
          <AppVersion classes="text-left q-ml-md q-mb-xs"></AppVersion>
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>
    <BasicModal refs="appHelperModal" title="Shortcuts" min-width="50vw">
      <template slot="modal-data" slot-scope="props">
        <div class="row">
          <div class="col-md-12">
            <div v-for="shortcut in appSettings.shortcuts" class="helper q-mb-md q-mt-md">
              <div class="text-h6">
                <q-chip square color="primary-darkened text-white">
                  {{ shortcut.module }}
                </q-chip>
              </div>
              <q-markup-table square dense bordered separator="cell" flat>
                <tr v-for="item in shortcut.items">
                  <td>{{ item.name }}</td>
                  <td>{{ item.desc }}</td>
                  <td>
                    <q-chip>{{ item.shortcut }}</q-chip>
                  </td>
                </tr>
              </q-markup-table>
            </div>
          </div>
        </div>
      </template>
    </BasicModal>
    <schema-manager />
    <!-- optional -->
  </q-layout>
</template>

<script>
import Store from 'src/services/navigationService'
import Translation from 'src/application/global/components/common/translations/translation'
import { QChip } from 'quasar'
import { DatesMixin, GeneralsMixin, AppUpdateMixin, ScopeConfigMixin } from 'src/application/global/mixins/index'
import { BasicModal, StandardSideMenu, FreshWidgetButton } from 'src/application/global/components'
import simpleClock from 'src/application/global/components/common/clock/simple-clock'
import SchemaManager from '../pages/schemaManager.vue'
import VueOfflineMixin from 'vue-offline/mixin'
import acl from 'src/services/aclService'
import { openURL } from 'quasar'
import { AppVersion } from 'src/application/global/components'
import { debounce } from 'quasar'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Full',
  components: {
    SchemaManager,
    QChip,
    BasicModal,
    language: Translation,
    simpleClock,
    StandardSideMenu,
    AppVersion,
    FreshWidgetButton,
  },
  mixins: [GeneralsMixin, DatesMixin, VueOfflineMixin, AppUpdateMixin, ScopeConfigMixin],
  computed: {
    ...mapState({
      isProcessingRefreshToken: state => state.globalCMP.isProcessingRefreshToken,
      errors: state => state.globalCMP.errors,
      userInfo: state => state.globalCMP.userInfo.data,
      appSettings: state => state.globalCMP.appSettings,
      selectedFilters: state => state.globalCMP.selectedFilters,
      countriesOptions: state => state.globalCMP.countriesOptions.data,
      websocket: state => state.globalCMP.websocket,
    }),
    ...mapGetters(['getSelectedFilters', 'getStandardMenu', 'isAnyModalActive', 'getIsLoading']),
  },
  watch: {
    /** Watch globalFilters countryID changes to re-apply permissions **/
    getSelectedFilters: {
      async handler(current) {
        if (!acl.disable && current.countryID !== acl.country) {
          await acl.aclRefresh({
            country: current.countryID,
          })
        }
      },
      deep: true,
    },
    '$wait.any'(to) {
      this.processLoading(to)
    },
  },
  async mounted() {
    await this.appInit()
  },
  async created() {
    // For smooth show/hide loading effect
    this.hideLoading = debounce(this.hideLoading, this.appSettings.mainLoadingDebounceDelay)
    this.processLoading = debounce(this.processLoading, this.appSettings.mainLoadingProcessDebounceDelay)
  },
  data() {
    return {
      leftDrawerOpen: true,
      onlineState: navigator.onLine,
      sidebarSearch: '',
      searchData: {},
      store: Store.state,
      notificationCount: 0,
      version: '',
      companyName: '',
      openURL,
      showLoading: false,
    }
  },
  methods: {
    ...mapActions(['getCountriesAction', 'isProcessingAction', 'getUserDetailsAction', 'setLoading']),
    appInit() {
      this.getCountriesAction()
    },
    resetScroll(el, done) {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      done()
    },
    getCountryCode() {
      let code = ''
      if (this.countriesOptions.options.length > 0) {
        let item = this.countriesOptions.options.find(x => x.value === this.selectedFilters.countryID)
        if (item !== undefined) {
          code = item.code_iso_2
        }
      }
      return code
    },
    refreshNotification() {
      if (this.websocket.channels.length > 0) {
        this.notificationCount = this.websocket.channels.length
        this.$refs.audioElm.play()
      }
    },
    updateGlobalCountry(value, updateGlobal = true) {
      this.$q
        .dialog({
          title: 'Warning',
          message: this.$t('Common.UpdateGlobalCountryInfo.Text'),
          cancel: {
            glossy: true,
            color: 'negative',
            label: 'No',
          },
          ok: {
            glossy: true,
            color: 'positive',
            label: 'Yes',
          },
        })
        .onOk(() => {
          if (updateGlobal) {
            this.setFilterData({
              countryID: value,
            })
          }
          window.location.reload()
        })
    },
    processLoading(to) {
      if (to) {
        this.setLoading(true)
      } else {
        this.hideLoading()
      }
    },
    hideLoading() {
      this.setLoading(false)
    },
  },
}
</script>
<style>
/*Skip css loader*/
@import '~intro.js/introjs.css';
</style>
